import request from '@/utils/request';
import { BASE_API } from '@/utils/consts'

// 查询订单收款信息
export function queryOrderPaymentList(data) {
  return request(`${BASE_API}/payment/list`, {
    method: 'post',
    data
  })
}

// 新增订单收款信息
export function addOrderPayment(data) {
  return request(`${BASE_API}/payment/create`, {
    method: 'post',
    data
  })
}

// 修改订单收款信息
export function updateOrderPayment(data) {
  return request(`${BASE_API}/payment/update`, {
    method: 'put',
    data
  })
}

// 删除订单收款信息
export function deleteOrderPayment(id) {
  return request(`${BASE_API}/payment/delete/${id}`, {
    method: 'delete'
  });
}

// 添加退款
export function addOrderRefund(data) {
  return request(`${BASE_API}/refund/save`, {
    method: 'post',
    data
  })
}

//条码支付 B扫C
export function onlinePayment(data) {
  return request(`${BASE_API}/leshua/payment/authCodeOrder`, {
    method: 'post',
    data
  })
}

//查看诊所商户
export function getMerchantInfo(data) {  
  return request(`${BASE_API}/merchant/show`,{
    method: 'GET',
    data
  })
}

//交易查询接口
export function getPaymentResult(data) {  
  return request(`${BASE_API}/leshua/payment/query`,{
    method: 'GET',
    data
  })
}

//线上退款
export function handleOnlineRefund(data) {  
  return request(`${BASE_API}/leshua/payment/refund`,{
    method: 'POST',
    data
  })
}

//取消扫码，状态变更为支付失败
export function cancelPayment(data) {  
  return request(`${BASE_API}/payment/cancel/${data.paymentId}`,{
    method: 'PUT'
  })
}